import { ButtonIcon, ButtonIconVariant, delay, PropsWithAria, PropsWithClassName } from "kz-ui-sdk";
import { MdArrowBack } from "react-icons/md";
import { NavigateOptions, useNavigate } from "react-router-dom";
interface BackButtonProps extends PropsWithClassName, PropsWithAria {
  to?: string;
  variant?: ButtonIconVariant;
  replace?: boolean;
  navigateOptions?: NavigateOptions;
  onClick?: () => void;
  "data-element-id"?: string;
  dir?: "ltr" | "rtl";
}

const BackButton = ({
  to,
  className,
  onClick,
  variant = "ghost",
  navigateOptions,
  ["aria-label"]: ariaLabel,
  "data-element-id": dataElementId = "button-back",
}: BackButtonProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    delay(200).then(() => {
      if (onClick) {
        onClick();
        return;
      }
      if (to) {
        navigate(to, navigateOptions);
      } else {
        navigate(-1);
      }
    });
  };

  return (
    <ButtonIcon
      onClick={handleClick}
      className={className}
      variant={variant}
      icon={
        <MdArrowBack
          size={24}
          aria-label={ariaLabel || "Back"}
          className="invert-x"
        />
      }
      aria-label={ariaLabel || "Back"}
      data-element-id={dataElementId}
    />
  );
};

export default BackButton;
